module.exports = __webpack_public_path__ + "img/koala.0b08910.png";